<template>
  <span
    class="text-2xs inline-flex items-center gap-1 rounded-full px-1 py-[3px] font-medium"
    :class="
      delta.direction === 'up'
        ? 'bg-background-negative-invisible text-text-negative-primary'
        : 'bg-background-positive-invisible text-text-positive-primary'
    "
  >
    <PriceUpIcon v-if="delta.direction === 'up'" class="size-4 shrink-0" />
    <PriceDownIcon v-else class="size-4 shrink-0" />
    <span>{{ sign }}{{ delta.formatted }}</span>
  </span>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  import type { PriceHistoryDelta } from '@/features/favorites';

  import PriceDownIcon from '@/assets/images/price-down-icon.svg?component';
  import PriceUpIcon from '@/assets/images/price-up-icon.svg?component';

  const props = defineProps<{
    delta: PriceHistoryDelta;
  }>();

  const sign = computed(() => (props.delta.direction === 'up' ? '+ ' : '− '));
</script>
